import React from "react";
import { Box, Button } from "@mui/material";

const EmployeeTabs = ({ tabs, activeTab, onChange }) => {
  return (
    <Box
      sx={{
        display: "flex",
        borderBottom: "1px solid #e5e7eb",
        mb: 3,
      }}
    >
      {tabs.map((tab) => (
        <Button
          key={tab}
          onClick={() => onChange(tab)}
          sx={{
            textTransform: "none",
            color: activeTab === tab ? "black" : "gray",
            borderBottom:
              activeTab === tab ? "3px solid #3B82F6" : "3px solid transparent",
            pb: 1,
            px: 3,
            fontWeight: activeTab === tab ? 600 : 400,
          }}
        >
          {tab}
        </Button>
      ))}
    </Box>
  );
};

export default EmployeeTabs;
